import React from 'react'
import ContactedPage from "./ContactedPage"

const NegotiationPage = () => {
  return (
    <div>
      <ContactedPage />
    </div>
  )
}

export default NegotiationPage
